const normalizeModelName = (name: string): string => name
  .trim()
  .replace(/\\/g, '/')
  .replace(/^\.\/+/, '')
  .replace(/\/{2,}/g, '/')
  .toLowerCase()

const basename = (name: string): string => normalizeModelName(name).split('/').pop() ?? ''

/**
 * Resolve a saved/merged model name to the exact value advertised by one server.
 * ComfyUI may expose the same file as either a basename or a relative subfolder path.
 */
export function resolveModelName(requested: string, available: string[]): string | null {
  if (!requested || !available.length) return null
  if (available.includes(requested)) return requested

  const normalized = normalizeModelName(requested)
  const fullMatches = available.filter((candidate) => normalizeModelName(candidate) === normalized)
  if (fullMatches.length === 1) return fullMatches[0]

  const requestedBasename = basename(requested)
  const basenameMatches = available.filter((candidate) => basename(candidate) === requestedBasename)
  return basenameMatches.length === 1 ? basenameMatches[0] : null
}
